export const ONE_SECOND = 1000;
export const LIMIT_BUTTON_TIMER = 25;
export const INICIAL_POINTS = 10;
export const EASY = 1;
export const MEDIUM = 2;
export const HARD = 3;
export const LIMIT_INDEX_QUESTIONS = 4;
export const EXPIDER_TOKEN_RESULT = 3;
